import { MONTHS } from '@/constants/constants'

const pad = (str: number) => `${str}`.padStart(2, '0')

export const toDateTime = (
  ts: string,
  isShort = false,
  dateFormat: boolean,
  timeFormat: boolean
) => {
  if (!ts) {
    return ''
  }

  const today = new Date()
  const dt = new Date(ts)

  const diff = Math.round(
    (today.getTime() - dt.getTime()) / (1000 * 60 * 60 * 24)
  )
  if (diff < 1) {
    if (timeFormat) {
      const hours = dt.getHours()
      const minutes = dt.getMinutes()
      const ampm = hours >= 12 ? 'PM' : 'AM'
      const hours12 = hours % 12
      const hours12Str = hours12 || 12
      const minutesStr = pad(minutes)
      return `${hours12Str}:${minutesStr} ${ampm}`
    }
    return `${dt.getHours()}:${pad(dt.getMinutes())}`
  }
  if (diff >= 1 && diff < 2) {
    return isShort ? '1d' : '1 day ago'
  }
  if (diff >= 2 && diff < 8) {
    return isShort ? `${diff}d` : `${diff} days ago`
  }
  return isShort
    ? dateFormat
      ? `${dt.getDate()} ${MONTHS[dt.getMonth()]}`
      : `${MONTHS[dt.getMonth()]} ${dt.getDate()}`
    : dateFormat
      ? `${dt.getDate()} ${MONTHS[dt.getMonth()]}, ${dt.getFullYear()}`
      : `${MONTHS[dt.getMonth()]} ${dt.getDate()}, ${dt.getFullYear()}`
}
